module.exports = __webpack_public_path__ + "img/ic_16_check.c45ff86b.svg";